<template>
  <div class="parameter-row" :class="{ 'parameter-row--compact': compact }">
    <div class="parameter-label">{{ title }}</div>
    <div class="parameter-options">
      <button
        v-for="item in items"
        :key="item.id"
        type="button"
        class="parameter-option"
        :class="{ 'parameter-option--active': String(row[field]) === String(item.id) }"
        :aria-pressed="String(row[field]) === String(item.id)"
        @click="selectOption(item, $event)"
      >
        {{ item[labelField] || item.name || item.short_code }}
      </button>
      <span v-if="!items.length" class="parameter-empty">No options available</span>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['change'],
  props: {
    title: String,
    field: String,
    labelField: String,
    items: Array,
    row: Object,
    compact: Boolean
  },
  methods: {
    selectOption(item, event) {
      this.row[this.field] = item.id
      this.$emit('change', item.id)
      event.currentTarget.blur()
    }
  }
}
</script>

<style scoped>
.parameter-row {
  display: grid;
  grid-template-columns: 105px minmax(0, 1fr);
  gap: 14px;
  align-items: start;
  padding: 12px 0;
  border-bottom: 1px solid #d9dee8;
}

.parameter-label {
  padding-top: 7px;
  color: #273142;
  font-size: 13px;
  font-weight: 600;
}

.parameter-options {
  display: flex;
  flex-wrap: wrap;
  gap: 7px 10px;
  min-width: 0;
}

.parameter-option {
  min-height: 30px;
  padding: 5px 14px;
  border: 1px solid #d7deea;
  border-radius: 6px;
  background: #fff;
  color: #273142;
  font-size: 12px;
  line-height: 18px;
  user-select: none;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.parameter-option:hover {
  border-color: #8d96a5;
  background: #f5f6f8;
}

.parameter-option--active {
  border-color: #164e63;
  background: #164e63;
  color: #fff;
  font-weight: 600;
}

.parameter-option--active:hover,
.parameter-option--active:focus,
.parameter-option--active:focus-visible,
.parameter-option--active:active {
  border-color: #164e63;
  outline: none;
  background: #164e63;
  color: #fff;
}

.parameter-empty {
  padding: 7px 0;
  color: #8b95a7;
  font-size: 12px;
}

.parameter-row--compact {
  grid-template-columns: 105px minmax(0, 1fr);
  border-bottom: 0;
}

@media (max-width: 767px) {
  .parameter-row {
    grid-template-columns: 1fr;
    gap: 7px;
  }

  .parameter-label {
    padding-top: 0;
  }
}
</style>
